// extracted by mini-css-extract-plugin
export var active = "_3j-7";
export var container = "_3j-0";
export var evenWidth = "_3j-4";
export var large = "_3j-5";
export var outlet = "_3j-8";
export var slide = "_3j-2";
export var small = "_3j-6";
export var tab = "_3j-3";
export var tabs = "_3j-1";